import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill="currentColor">
      <path d="M10.2 3.8a.8.8 0 011.025-.767l.1.037 9 4a.8.8 0 01.105 1.406l-.105.056L11.8 12.32v5.48a.8.8 0 01-.7.795l-.1.006a.8.8 0 01-.794-.7l-.006-.1v-14zm1.6 1.232v5.537L18.029 7.8 11.8 5.03zM18.743 17.504c1.485 3.713-.015 6.469-4.218 7.962l-.272.094-.506-1.518c3.502-1.168 4.606-2.978 3.59-5.735l-.08-.209 1.486-.594z" />
      <path d="M21 17a.8.8 0 01.1 1.595l-.1.006h-8.819l3.562 8.903a.8.8 0 01-.348.993l-.098.047a.8.8 0 01-.993-.348l-.047-.098-4-10a.8.8 0 01.64-1.09L11 17h10z" />
    </g>
  </svg>
);

const IconCorners = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconCorners;
